import { Component, ElementRef, EventEmitter, HostBinding, Inject, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild } from '@angular/core';
import { ScheduleLesson } from '../../../interfaces/schedule';
import { LocationSelectPickerComponent } from '../../location-select-picker/location-select-picker.component';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { DOCUMENT } from '@angular/common';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';

declare var moment: any;
declare var ics: any;

@Component({
  selector: 'app-lesson-details',
  templateUrl: './lesson-details.component.html',
  styleUrls: ['./lesson-details.component.scss', './lesson-details.component.en.scss']
})
export class LessonDetailsComponent implements OnInit, OnDestroy {
  @Input({ required: true }) event!: ScheduleLesson;
  @Input() nooficationText: string = '';
  @Input() nooficationCount: number = 0;
  @HostBinding('style.--lesson-border-color') @Input() color?: string;
  @HostBinding('class.opened') opened: boolean = false;
  @Output() close: EventEmitter<void> = new EventEmitter<void>();
  @Output() openNotification: EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('locatinPicker') locatinPicker!: LocationSelectPickerComponent;

  private escListener: any;
  private clickListener: any;

  constructor(private eRef: ElementRef, 
    private renderer: Renderer2, 
    @Inject(DOCUMENT) private document: Document, 
    private userAgentService: UserAgentService) {
    this.escListener = this.handleEscKey.bind(this);
    window.addEventListener('keydown', this.escListener);
  }
  
  ngOnInit() {
    setTimeout(() => {
      this.opened = true;

      this.clickListener = this.onOutsideClick.bind(this);
      document.addEventListener('click', this.clickListener);
    });
  }

  ngOnDestroy(): void {
    window.removeEventListener('keydown', this.escListener);
  }

  closeEvent() {
    this.opened = false;

    if(this.clickListener) {
      document.removeEventListener('click', this.clickListener);
      this.clickListener = null;
    }

    this.close.emit();
  }

  private handleEscKey(event: KeyboardEvent): void {
    if (this.opened && (event.key === 'Escape' || event.keyCode === 27)) {
      this.closeEvent();
    }
  }

  onOutsideClick(event: any) {
      if (this.opened && !this.eRef.nativeElement.contains(event.target)) {
          this.closeEvent();
      }
  }

  openNotificationClick(event: any) {
    event.preventDefault();
    this.openNotification.emit();
    this.changeNotificationPopupMobileStyle(true);
  }

  addToCalendarClick(type: CalendarItemEnum) {
    switch (type) {
      case CalendarItemEnum.Gmail:
        this.addGoogleCalendarEvent();
        break;
      case CalendarItemEnum.Outlook:
        this.addOutlookCalendarEvent();
        break;
      case CalendarItemEnum.Desktop:
        this.downloadDesktopCalendarEvent();
        break;
      default:
        break;
    }
  }

  private addGoogleCalendarEvent() {
    let startDate = moment(this.event.date).format('YYYYMMDDTHHmmss');
    let duration = this.event.timeEnd - this.event.timeStart;
    let endDate = moment(this.event.date).add(duration, 'hours').format('YYYYMMDDTHHmmss');
    let link = [
      'https://www.google.com/calendar/render',
      '?action=TEMPLATE',
      '&text=' + encodeURIComponent(this.event.name),
      '&dates=' + startDate + '/' + endDate,
    ];

    if (this.event.type) {
      link.push('&details=' + encodeURIComponent(this.event.type));
    }
    if (this.event.location) {
      link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private addOutlookCalendarEvent() {
    let startDate = moment(this.event.date).format('YYYY-MM-DDTHH:mm:ss');
    let duration = this.event.timeEnd - this.event.timeStart;
    let endDate = moment(this.event.date).add(duration, 'hours').format('YYYY-MM-DDTHH:mm:ss');

    let link = [
      'https://outlook.live.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=add',
      '&startdt=' + encodeURIComponent(startDate),
      '&enddt=' + encodeURIComponent(endDate),
      '&subject=' + encodeURIComponent(this.event.name),
    ];

    if (this.event.type) {
      link.push('&body=' + encodeURIComponent(this.event.type));
    }

    if (this.event.location) {
      link.push('&location=' + encodeURIComponent(this.event.location));
    }

    window.open(link.join(''), '_blank');
  }

  private downloadDesktopCalendarEvent() {
    let startDate = moment(this.event.date).format('YYYY-MM-DDTHH:mm:ss');
    let duration = this.event.timeEnd - this.event.timeStart;
    let endDate = moment(this.event.date).add(duration, 'hours').format('YYYY-MM-DDTHH:mm:ss');
    var cal = ics();
    cal.addEvent(
      this.event.name,
      this.event.type,
      this.event.location,
      startDate,
      endDate
    );
    cal.download();
  }

  changeNotificationPopupMobileStyle(opened: boolean) {
    setTimeout(() => {
      let eventPopup = this.document.querySelector('.cal-event-popup') as HTMLElement;
      let notificationPopup = this.document.querySelector('.notifications-modal') as HTMLElement;
      if(this.userAgentService.isMobileDevice()) {
          if(opened) {
            this.renderer.setStyle(eventPopup, 'z-index', '999');
            this.renderer.setStyle(notificationPopup, 'z-index', '9999');
          } else {
            this.renderer.removeStyle(eventPopup, 'z-index');
          }
      } else {
        if(opened) {
          this.renderer.setStyle(notificationPopup, 'width', '35rem');
          this.renderer.setStyle(notificationPopup, 'text-align', 'justify');
        }
      }
    }, 10);
  }
}
